import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export default function ImagePreviewModal({ show, onHide, file }) {
    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{file?.original_filename || 'Preview'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                {file && (
                    <img
                        src={file.url}
                        alt={file.original_filename}
                        style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                {file && (
                    <Button as="a" href={file.url} target="_blank" rel="noopener noreferrer" variant="primary">
                        Open in new tab
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}
